import React from "react";
import Marquee from "react-fast-marquee";
import { useTranslation } from "react-i18next";

export const Ribbon = () => {
  const { t } = useTranslation();
  const items = t("ribbon.items", { returnObjects: true }) || [];

  return (
    <div
      data-testid="ribbon"
      className="bg-[#2A3563] py-4 border-y border-[#2A3563]"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {(Array.isArray(items) ? items : []).map((label, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-bold uppercase tracking-[0.2em] text-white text-sm md:text-base mx-8">
              {label}
            </span>
            <span className="text-[#C86A3D] text-lg">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
